"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "reggio-calabria": {
    "aa4768f6": [{
      "hkey": "11dc767a",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "centro": [{
      "hkey": "11dc767a",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "reggio-calabria"
    }],
    "04923e54": [{
      "hkey": "191a23b5",
      "slug": "archi-pentimele",
      "name": "Archi, Pentimele",
      "primary": true,
      "skipSearch": false
    }],
    "pentimele": [{
      "hkey": "191a23b5",
      "slug": "archi-pentimele",
      "name": "Archi, Pentimele",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "reggio-calabria"
    }],
    "588f26ba": [{
      "hkey": "11dc767a",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "45c177ac",
      "slug": "trabocchetto",
      "name": "Trabocchetto",
      "primary": false,
      "skipSearch": false
    }],
    "reggio-campi": [{
      "hkey": "11dc767a",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "reggio-calabria"
    }],
    "4718162e": [{
      "hkey": "21c6b520",
      "slug": "santa-caterina",
      "name": "Santa Caterina",
      "primary": true,
      "skipSearch": false
    }],
    "s-caterina": [{
      "hkey": "21c6b520",
      "slug": "santa-caterina",
      "name": "Santa Caterina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "94e02127": [{
      "hkey": "dba80398",
      "slug": "via-calabria-viale-europa-viale-aldo-moro",
      "name": "Via Calabria, Viale Europa, Viale Aldo Moro",
      "primary": true,
      "skipSearch": false
    }],
    "via-galileo-galilei": [{
      "hkey": "dba80398",
      "slug": "via-calabria-viale-europa-viale-aldo-moro",
      "name": "Via Calabria, Viale Europa, Viale Aldo Moro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "reggio-calabria"
    }],
    "122afb3c": [{
      "hkey": "dba80398",
      "slug": "via-calabria-viale-europa-viale-aldo-moro",
      "name": "Via Calabria, Viale Europa, Viale Aldo Moro",
      "primary": true,
      "skipSearch": false
    }],
    "via-gebbione": [{
      "hkey": "dba80398",
      "slug": "via-calabria-viale-europa-viale-aldo-moro",
      "name": "Via Calabria, Viale Europa, Viale Aldo Moro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "reggio-calabria"
    }],
    "43be41b3": [{
      "hkey": "dba80398",
      "slug": "via-calabria-viale-europa-viale-aldo-moro",
      "name": "Via Calabria, Viale Europa, Viale Aldo Moro",
      "primary": true,
      "skipSearch": false
    }],
    "viale-aldo-moro": [{
      "hkey": "dba80398",
      "slug": "via-calabria-viale-europa-viale-aldo-moro",
      "name": "Via Calabria, Viale Europa, Viale Aldo Moro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "reggio-calabria"
    }],
    "b50f7f17": [{
      "hkey": "dba80398",
      "slug": "via-calabria-viale-europa-viale-aldo-moro",
      "name": "Via Calabria, Viale Europa, Viale Aldo Moro",
      "primary": true,
      "skipSearch": false
    }],
    "viale-calabria": [{
      "hkey": "dba80398",
      "slug": "via-calabria-viale-europa-viale-aldo-moro",
      "name": "Via Calabria, Viale Europa, Viale Aldo Moro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "reggio-calabria"
    }],
    "726c6cf1": [{
      "hkey": "dba80398",
      "slug": "via-calabria-viale-europa-viale-aldo-moro",
      "name": "Via Calabria, Viale Europa, Viale Aldo Moro",
      "primary": true,
      "skipSearch": false
    }],
    "viale-europa": [{
      "hkey": "dba80398",
      "slug": "via-calabria-viale-europa-viale-aldo-moro",
      "name": "Via Calabria, Viale Europa, Viale Aldo Moro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "reggio-calabria"
    }]
  }
};
exports["default"] = _default;